<template>
  <div class="container-table-list">
    <table id="table-list">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
          >
            <div class="table-header">
              <span>
                {{ column.text }}
              </span>
              <div
                v-if="isUseSort && column.sort"
                class="table-header-sort"
                @click="handleSorting(column)"
              >
                <i
                  :class="{'active' : activeColumn === column.key && sort === 1}"
                  class="fa fa-chevron-up"
                />
                <i
                  :class="{'active' : activeColumn === column.key && sort === -1}"
                  class="fa fa-chevron-down"
                />
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <slot name="table-body"/>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    sorting: {
      type: Object,
      default: null,
    },
    isUseSort: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      activeColumn: null,
      sort: null,
    };
  },

  created() {
    if (this.isUseSort && this.sorting) {
      this.activeColumn = Object.keys(this.sorting)[0];
      this.sort = Object.values(this.sorting)[0];
    }
  },

  methods: {
    handleSorting(column) {
      if (column.sort) {
        let param = null;
        this.sort = this.sort === 1 ? -1 : 1;
        if (column.key === this.activeColumn) {
          param = {
            [column.key]: this.sort,
          };
        } else {
          this.sort = 1;
          this.activeColumn = column.key;
          param = {
            [column.key]: this.sort,
          };
        }
        this.$emit('sort-change', param);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/table/jTableList.vue